"use client";

import React, { useState } from "react";
import { RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUniversalEntityPageContext } from "../contexts/UniversalEntityPageContext";
import type { BaseEntity } from "../../UniversalCRMTable/types";

/**
 * Refetches entity list data via UniversalEntityPageContext (same behavior as the default entity header).
 * Use from custom headers so table refresh matches companies/contacts.
 */
export function EntityTableRefreshButton<T extends BaseEntity>() {
  const [isRefreshing, setIsRefreshing] = useState(false);

  let context;
  try {
    context = useUniversalEntityPageContext<T>();
  } catch {
    context = null;
  }

  if (!context) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      className="h-8 w-8 p-0 border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800"
      title="Refresh data"
      onClick={async () => {
        setIsRefreshing(true);
        try {
          await Promise.resolve(context.dataState.refetch());
        } finally {
          setTimeout(() => setIsRefreshing(false), 600);
        }
      }}
      disabled={isRefreshing || context.dataState.isLoading}
    >
      <RotateCw className={`h-4 w-4 ${isRefreshing ? "animate-spin" : ""}`} />
    </Button>
  );
}
